var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_9137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8418 17.6449C20.5091 18.4135 20.1153 19.1211 19.659 19.7715C19.0371 20.6583 18.5278 21.2721 18.1354 21.613C17.527 22.1724 16.8752 22.459 16.1772 22.4753C15.6761 22.4753 15.0718 22.3327 14.3683 22.0434C13.6626 21.7555 13.014 21.613 12.421 21.613C11.7991 21.613 11.132 21.7555 10.4185 22.0434C9.70396 22.3327 9.12831 22.4834 8.68819 22.4984C8.01884 22.5269 7.35166 22.2322 6.68571 21.613C6.26066 21.2422 5.72901 20.6067 5.09212 19.7063C4.40878 18.7449 3.84698 17.63 3.40686 16.3589C2.93551 14.986 2.69922 13.6565 2.69922 12.3694C2.69922 10.8951 3.0178 9.62345 3.65592 8.55784C4.15742 7.70191 4.82459 7.02672 5.65962 6.53105C6.49464 6.03539 7.39688 5.7828 8.36852 5.76664C8.90017 5.76664 9.59736 5.93109 10.4637 6.25429C11.3277 6.57858 11.8824 6.74303 12.1256 6.74303C12.3075 6.74303 12.9237 6.55074 13.9684 6.16738C14.9564 5.81186 15.7902 5.66466 16.4732 5.72264C18.3241 5.87202 19.7147 6.60167 20.6395 7.91619C18.9841 8.9192 18.1653 10.324 18.1816 12.1262C18.1965 13.53 18.7057 14.6981 19.7066 15.6256C20.1601 16.0561 20.6667 16.3888 21.2302 16.6251C21.108 16.9795 20.979 17.319 20.8418 17.6449ZM16.5968 0.940369C16.5968 2.04062 16.1948 3.06792 15.3936 4.01878C14.4267 5.14917 13.2572 5.80236 11.989 5.69929C11.9729 5.56729 11.9635 5.42837 11.9635 5.28239C11.9635 4.22615 12.4233 3.09576 13.2399 2.17152C13.6475 1.70356 14.166 1.31445 14.7948 1.00406C15.4221 0.698295 16.0156 0.529201 16.5737 0.500244C16.59 0.647331 16.5968 0.794426 16.5968 0.940355V0.940369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_9137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.e83e98cf9b5a7d91ab40bda4c88b6fd5.svg";
export { ForwardRef as ReactComponent };